import React from 'react';
import {Card, CardHeader, CardBody} from 'reactstrap';
import { useSelector } from 'react-redux';
import Loader from '../../../components/common/Loader';
 
const SalesConsumptionPredictionCard = ({ xx, probabilitys }) => {
    const isLoading =  useSelector(state => state.audienceSalesPrediction.loading);

    return (
        <Card
            className="card-height-100 d-flex align-items-center"
            style={{
                boxShadow: "2px 2px 5px rgba(0, 0, 0, 0.2)",
                borderRadius: "5px",
                marginLeft: "10px",
            }}
        >
            <CardHeader className="d-flex">
                <h4 className="card-title mb-0 flex-grow-1">
                    <b>Sales / Consumption Prediction</b>
                </h4>
            </CardHeader>

            {isLoading ? (
                <CardBody className="d-flex justify-content-center align-items-center" style={{ height: '350px' }}>
                    <Loader />
                </CardBody>
            ) : (
                probabilitys.length > 0 ? (
                    <CardBody className="w-100">
                        {
                                  <div
                                  className="table-responsive table-card h-100"
                                  style={{
                                      minHeight: "285px",
                                      maxHeight: "285px",
                                      overflowY: "auto",
                                      padding: "15px",
                                  }}
                              >
                
                                  <table className="table table-centered align-middle mb-0">
                                      <tbody>
                                          {
                                              xx &&
                                              [...probabilitys]
                                              .sort((a, b) => b.probability - a.probability)
                                              .map((predictions, index) => (
                                              <tr key={index}>
                                                  <td className="p-1">
                                                      <div className="d-flex align-items-center">
                                                          <div className="flex-shrink-0 me-2">
                                                              <i className="ri-focus-fill fs-18 text-secondary"> </i>
                                                          </div>
                                                          <div>
                                                              <h5 className="fs-14 my-1 fw-medium">
                                                                  {xx === true ? predictions.name : "UNKNOWN"}
                                                              </h5>
                                                              <span className="text-muted">
                                                                  Product
                                                              </span>
                                                          </div>
                                                      </div>
                                                  </td>
                                                  <td>
                                                  </td>
                                                  <td>
                                                      <h5 className="fs-14 mb-0 text-end">
                                                          <b>{xx === true ? predictions.probability.toFixed(1) + "%" : "UNKNOWN"}</b>
                                                          <i className="ri-bar-chart-fill text-secondary fs-16 align-middle ms-2"></i>
                                                      </h5>
                                                  </td>
                                              </tr>
                                          ))}
                                      </tbody>
                                  </table>
                              </div>
                        }
                    </CardBody>
                ) : (
                    <CardBody className="w-100">
                        {
                                   <div
                                   className="table-responsive table-card h-100"
                                   style={{
                                       minHeight: "285px",
                                       maxHeight: "285px",
                                       overflowY: "auto",
                                       padding: "15px",
                                   }}
                               >
                                   <table className="table table-centered align-middle mb-0">
                                           <tbody>
                                           <tr>
                                                       <td colSpan="3" className="text-center">
                                                           No Data Available
                                                       </td>
                                                   </tr>
                                           </tbody>
                                           </table>
                   
                                   </div>
                        }
                    </CardBody>
                )
            )}
        </Card>
    );
};

export default SalesConsumptionPredictionCard;
